import React, { useState, useEffect } from 'react';
import {
  Box,
  Typography,
  useMediaQuery,
  IconButton,
  Paper,
  Alert,
  Tabs,
  Tab,
  TextField,
  Button,
} from '@mui/material';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import LeftSidebar from './LeftSidebar.tsx';
import QueryInterface from './QueryInterface.tsx';
import ChatInputBox from './ChatInputBox.tsx';
// import { BeautifyText } from './BeautifyText.tsx';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { AiActions } from '../../Services/_actions';
import { useSnackBar } from '../FlowBuilder/Common/SnackBar/index.tsx';
import { useRecoilState, useSetRecoilState } from 'recoil';
import { aiStateAtom, projectAndQueryListAtom } from '../../Services/_states/index.js';
import './AI-dashboard.css';
import { JoinFull } from '@mui/icons-material';
import MDAI from './Logo/MDAI.png';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import ModalForms from '../Shared/Modals/index.js';
import BeautifyMarkdown from './Beautifymarkdown.tsx';

export type AIModel =
  | 'chatgpt'
  | 'gemini'
  | 'deepseek'
  | 'metaai'
  | 'perplexity'
  | 'claude'
  | 'grok'
  | 'mdai';

export interface Query {
  id?: number;
  name?: string;
  query: string;
  timestamp?: Date;
  status?: 'pending' | 'completed' | 'error';
  AImodel: AIModel;
  response?: string;
  conversation_id: string;
  created_at: Date | string;
}

interface AIModelConfig {
  model: AIModel;
  label: string;
  color: string;
}

const aiModels: AIModelConfig[] = [
  { model: 'mdai', label: 'MD AI', color: '#ffff' },
  { model: 'chatgpt', label: 'ChatGPT', color: '#ffff' },
  { model: 'gemini', label: 'Gemini', color: '#ffff' },
  { model: 'claude', label: 'Claude', color: '#ffff' },
  { model: 'grok', label: 'Grok', color: '#ffff' },
  // { model: 'perplexity', label: 'Perplexity', color: '#20808d' },
  { model: 'metaai', label: 'Meta AI', color: '#ffff' },
  // { model: 'deepseek', label: 'DeepSeek', color: '#6366f1' },
];

// AI Window Content Component
interface AIWindowContentProps {
  aiModel: AIModel;
  aiLabel: string;
  selectedQuery: Query | null;
  submitQuery: (text: string, context?: any) => void;
  loading: boolean;
  lastQueryText: string;
  lastQuerySource: 'QueryInterface' | 'AISelection' | null;
  response?: string;
  conversationId?: string;
  historyRefresh: number;
}

const aiLogos: Record<AIModel, string> = {
  mdai: '/favicon.ico',
  chatgpt:
    'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAYAAAA7MK6iAAAACXBIWXMAAAsTAAALEwEAmpwYAAAC/0lEQVR4nO2WS0iVQRTHf5k9TCQ1CimKqDAkcFUUZoa9FrWQFiK1TAgi7AHh3UhQRFHRa5FlEGUPoU24KyqpXZRkL0OCCNIem1Zp3lLzi4H/xGH4vnt72M4/XLgzc2b+M+f8zzkfjCMZk4HtwGPgK9APdAFNQCH/CfOB10CU8PsIVI416SygTwRPgRpgOjANWAvc19oXvT4FbAWK/5X4gg6+C0wN1nKB3cBIjBeGgRNA3p+Q5QN7gQ7gB5AG5gQ264FuQ/QKOA7sB9pF7L1U+Duky4EPwe1vm/WFOtivvZH7Q5QZXbRlI10ixTrjh8AV/W/R+gzgs4mpi+eUDOctAgaAUaA0yWgC8ESHtgITgR0aN8tmtcY3gBKzd5m88hLYBuTEaKQxibhKBu+NIELiao2dLYp7q16UNu7vBCpkU6+5i0nEjTJwSiSBeI3GG5Q6AyI8DBQAW4Be2bjLXAcOaXwuifiIDHZlIF6ncb853Hmo1uxx+X0AGAwEujPbi4+aOe+m8yaFImmhStWqS3OukJSbvfMC9W9KIl5p0mOS5uYCn5STZ4A62fj4OazQ3JAKSbPU73HSxN2K7hdy1ACc0Skz7w45q0OHtO7IPCo0V6fLDeuy7tK+ubyVjXtcLDYa17TLXR7lpi47966Su30KujCgsEQKk8exbCnVEAhiUEJxgvGolaBGA6E54SFXRxKmxx7NOfXHokUGB5UK/vBepUqBNqeVSk1KrUiplkR8WnP7kogvycBVHx+/TuOBtJrGZWB2UHiqE4jz1K8zxjgV1GYvOneRF8AtYKlZK1H5jFROQ2JXdq8ZVbuyHItSude5cUGSkRpDSo0iUuMoDmrzVeCR0UEZWdAm4x5gccx6jXLdqt9e8k4g0D41kawoUvN2m74DNyUiJ6pn5sBuo2QPl7vflPP39HViMyIr8tQs/FeE/Y2onufG7OmI0chfoUhplNKrfUwf6LX5+qzZDDzX2jtgJmOMSpMacb+eoNqNKQr1+i6pdUCfSfWmuYyDED8BOKIZsmUtfr8AAAAASUVORK5CYII',
  gemini:
    'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAACXBIWXMAAAsTAAALEwEAmpwYAAAD3klEQVR4nO2a208UVxzHD8YLTaw+U30E3KLUCmhTEbdi4y1q01Rq0VZqpHuZyy67K3ub3TkoxoSoGIw+9H/o0uibjQHa9PLSB21MTGB3Zm8DOzO76FKf+TUHC7EI4gjszkn6+Qs+s/md336/Zwah/1mc245CbMBe+AHRyi17odjv0IuIRnAbrO936tPXnPr09zZYh2hjgM9vve7MQx+jQx+rv4do4zqjHyTyV1kdLjk1K6KNPkbzEPleVoceVnMj2rjKavdm5DkNoqz2I6KJG570O5cZ/TmRFzkNBC43xfOjGxAt9DL62Tl5XoWQS4Vu98RpRAs9nPrzy/J+lwpeV24Y0QBm1H3z5X3uHHjcOeC6lBZkZjCGNSKn/b6QvKsrB4x74heEoAKZFZHT7YvJs10T4PRMgN2jXEBmBLNabZjLFV8nb/OOwwWv8neHV7EgMxGwTW4O8+rjpeQ7veNw3jcO33iVR2f5/CZkBnCHXClwuZE3lT/nU+Driwp85VOGOrBcWV55Rt0o8OpPRuXbLypwujsLX/izI22BxObyyHO6xcjYzJc/5c/C5/4snAxk/joazNaWeFXqdhIPliv/WSADxwMZOBbIFI+GMt+t+oq9xGvWKKv9sdSqNCQfzMCRYBoOhdLwaTD1W2so1bLih/Qyq59ZKB6sqHwoBa3hFFjDKWgJJ0f2CXK71eghJzXwhj2/5ZpDb32R57V7/0mVpZGHZiEJHwtJ+CgiPd8tyHcbI7KnQYi37gynt9Thx+tfEb/jKAzesuef3nTmYbYGzpWRssnLsDsiQ2NUhl1RCT4QJdghSlCHE7BNjD+tFROxuQcYcBRi/U59kgZ5C05ADY5PVveMxV4dIQxrr9i0ql5G2485zSVy2uCKbhvj8lP1USm2Iyq53sfSfks4WWXFw2sNnQvSpEgZ8blzQyWTj0gPPhSltgXnfTlwXWozicSrJi/II01Cci9aXaCCROJOr1JcQflnTYJ8vqRd4dvuTA1JlcuWF+SHu/BYNSoHbYy6sd2Xvf+28nsi0vAePFreWE0i8Sl/dsj4Ly89qDbLVcsRPr+JpEojY7O3+8m7yEycCKarjwUzz5YeG3mqKSJtQ2bkcCDdudSqfLFtTAtUHAymfn3dnjf1tQrhk1CyebF/2IZowtwXW7OQPL9APBhCtNAcks/MD2YNEelLRAtWLFfOlJGXUqVpdv6bMtOk/s3z9WJiENFGY0T2zJaR7aJE3yumnVH5wGyTImUE0UY9Ht06VwPDySpEG422P9fV4fi0BcenDddAs2ARE8VaMUHnpwYEcvVRg8fo/dgDlYB/AK0IWrcIdgHFAAAAAElFTkSuQmCC',
  claude:
    'data:image/png;base64,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',
  grok: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAACXBIWXMAAAsTAAALEwEAmpwYAAADBUlEQVR4nO1ZW6hMURhe7pfINZppZv/ft/Z2RlMi8yBKEyUUDy4lDyJS5wUPwgspXpAHKR0vUpKIPBAPSkm5pERJJMqlE6fcciL30ersqWnaa505NZdV5qvVNHt/a/3f98+/12WPUm200UYb/zXCMJxH8jfJUnUDcEspNUT5inw+PwbAM4v4Xq31NOUzSJ5MEm+aiGwwnCAIZisfISIrbOJJXow5IwE8Ur4hm82mSb63iO9Op9OTDA/AMXNNeYZBAK5YxP8VkaWGBGCx+e6dAQDbHKVzxHA6Ojomk3xbvq58QRAEeZLfLOIfZzKZUYYH4HzlPeUDoigaQfKBZcr8LiKzDA/A5ur7ygeQPGQrHQA7DCcIAg3gi3cGSM53rLY3y6styTtJnJaK11qPI/nSIv4zAKkwWvLOAIAzNmFa67WV3LobsNVk3F7kcrmxrv4kVzvq/nQCv/6/AMmNDhEnbP2iKMqQ/GDp9yYIgglNMRAPfNZhYk1Cl8EArlv6/BGRBZY4pYYYEJHxAF5ZAnzSWgeVfAA7HavtQUeiSg17iAEUTfYsQW6YrMe8mWZhsvAemgWtJQYMABx2ZHa74URRFCY9+MaU1nqGcoCNNlDrdoDkpoT7W/sbn81YB2rdkJE8VyH+mtlGe2HAAMAWRykdNRwzTQJ4TfJjGIZZVQPYLAPxoeSyJaA5hCyLBS3SWq+sdVA20YDZ40wB8M7yPPSQnDrQMdlMAwbm+Fc+9iW0q7XUfUsNxEG7bIFFpHOAY5WaWUILzWcqlRpN8okl+FcRme6dgTAMCwB+AlhffvkE4IdFwP18Pj/cGwOpvow/rX79B2CXY2o94I0BkserZpx7hUJhWH870HLJtdSAiCxJmnUA7K3lDJDJZCa2zIDum/d7LEG6i8Xi0FjEKpsQABdaZgDAJUeNL68ScsphYl3TDYhIp0N8V73e+7MRBuL9fa9FzHMjtl7/vLDeBkxdk7xrEfELwBxXf5L7HKW0p+EGSO53CNhdYwJu2xIgInMbaqCNNtpQ3uMfYIUcVrfH4K8AAAAASUVORK5CYII',
  metaai: "data:image/png;base64,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",
};

const AIWindowContent: React.FC<AIWindowContentProps> = ({
  aiModel,
  aiLabel,
  selectedQuery,
  submitQuery,
  loading,
  lastQueryText,
  lastQuerySource,
  response,
  conversationId,
  historyRefresh,
}) => {
  const [chatInputState] = useRecoilState(aiStateAtom);
  const aiActions = AiActions();
  const [queryHistory, setQueryHistory] = useState<Query[]>([]);

  useEffect(() => {
    (async () => {
      let list = [];
      try {
        if (conversationId && aiModel) {
          const history = await aiActions.getChatHistory({
            ...chatInputState,
            ai_model: aiModel,
            conversation_id: conversationId,
          });
          if (history?.status === 200) {
            if (!Array.isArray(history?.data)) {
              list = [];
            } else {
              list = history?.data ?? [];
            }
          }
        }
      } catch (error) {
        console.error(`Error fetching chat history for ${aiModel}:`, error);
      } finally {
        setQueryHistory(list ?? []);
      }
    })();
  }, [conversationId, aiModel, historyRefresh]);

  return (
    <Paper
      sx={{
        px: { xs: 1, sm: 2 },
        py: { xs: 2, sm: 2 },
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: '#fff',
        boxSizing: 'border-box',
        gap: '5px',
      }}
      elevation={0}
    >
      {/* Chat Display Area */}
      <Box
        sx={{
          flexGrow: 1,
          overflowY: 'auto',
          p: { xs: '8px', sm: '8px', md: 2 },
          backgroundColor: '#f8fcfffa',
          border: '1px solid #cde2ff',
          borderRadius: 2,
          display: 'flex',
          flexDirection: 'column',
          gap: 2,
          height: { xs: '45vh', sm: '50vh', md: '50vh', lg: '55vh', xl: '65vh', xxl: '65vh' },
        }}
      >
        {queryHistory && (
          <Box sx={{ mt: 2, display: 'flex', flexDirection: 'column', gap: 2 }}>
            {queryHistory.length === 0 ? (
              <Typography color="text.secondary" alignSelf="center">
                No response yet.
              </Typography>
            ) : (
              queryHistory.map((q) => (
                <Box key={q.id} sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                  {/* Query bubble on right */}
                  <Box
                    sx={{
                      alignSelf: 'flex-end',
                      maxWidth: { xs: '100%', sm: '100%', md: '70%' },
                      bgcolor: '#eaf4ff',
                      p: 1.5,
                      borderRadius: '16px 16px 0 16px',
                      whiteSpace: 'pre-wrap',
                      boxShadow: '0 1px 1.5px rgba(0,0,0,0.2)',
                      wordBreak: 'break-word',
                      color: '#000',
                    }}
                  >
                    {q?.query}
                  </Box>

                  {/* Response bubble on left */}
                  <Box
                    sx={{
                      alignSelf: 'flex-start',
                      maxWidth: { xs: '100%', sm: '100%', md: '70%' },
                      bgcolor: '#f3f3f3',
                      color: '#000',
                      p: 1,
                      borderRadius: '16px 16px 16px 0',
                      wordBreak: 'break-word',
                      boxShadow: '0 1px 1.5px rgba(0,0,0,0.1)',
                    }}
                  >
                    {/* <BeautifyText text={q.response} /> */}
                  <BeautifyMarkdown text={q.response} />
                  </Box>
                </Box>
              ))
            )}
          </Box>
        )}

        {/* Show pending query */}
        {loading && lastQueryText && (
          <>
            <Box
              sx={{
                alignSelf: 'flex-end',
                maxWidth: { xs: '100%', sm: '100%', md: '70%' },
                bgcolor: '#eaf4ff',
                p: 1.5,
                borderRadius: '16px 16px 0 16px',
                wordBreak: 'break-word',
                boxShadow: '0 1px 1.5px rgba(0,0,0,0.2)',
                color: '#000',
              }}
            >
              <Typography variant="body1" whiteSpace="pre-line">
                {lastQueryText}
              </Typography>
            </Box>
            <Typography color="text.secondary" alignSelf="center">
              {aiLabel} is typing...
            </Typography>
          </>
        )}

        {/* Show response if available */}
        {response && !loading && (
          <Box
            sx={{
              alignSelf: 'flex-start',
              maxWidth: { xs: '100%', sm: '100%', md: '70%' },
              bgcolor: '#f3f3f3',
              color: '#000',
              p: 1,
              borderRadius: '16px 16px 16px 0',
              wordBreak: 'break-word',
              boxShadow: '0 1px 1.5px rgba(0,0,0,0.1)',
            }}
          >
            {/* <BeautifyText text={response} /> */}
            <BeautifyMarkdown text={response} />
          </Box>
        )}
      </Box>

      {/* Input Box */}
      {chatInputState?.selectedCampaign?.proposal_id ? (
        <ChatInputBox
          model={aiModel}
          loading={loading}
          onSubmit={(queryText, contextWithFiles) => {
            submitQuery(queryText, contextWithFiles);
          }}
        />
      ) : (
        <Alert severity="warning">First Select Organisation and Sector</Alert>
      )}
    </Paper>
  );
};

export default function AI() {
  const [chatInputState, setChatInputState] = useRecoilState(aiStateAtom);
  const setProjectAndQueryList = useSetRecoilState(projectAndQueryListAtom);
  const [selectedQuery, setSelectedQuery] = useState<Query | null>(null);
  const [lastQueryText, setLastQueryText] = useState<Record<AIModel, string>>({
    mdai: '',
    chatgpt: '',
    gemini: '',
    deepseek: '',
    metaai: '',
    perplexity: '',
    claude: '',
    grok: '',
  });
  const [lastQuerySource, setLastQuerySource] = useState<'QueryInterface' | 'AISelection' | null>(
    null
  );
  const [loading, setLoading] = useState<Record<AIModel, boolean>>({
    mdai: false,
    chatgpt: false,
    gemini: false,
    deepseek: false,
    metaai: false,
    perplexity: false,
    claude: false,
    grok: false,
  });
  const [responses, setResponses] = useState<Record<AIModel, string | undefined>>({
    mdai: undefined,
    chatgpt: undefined,
    gemini: undefined,
    deepseek: undefined,
    metaai: undefined,
    perplexity: undefined,
    claude: undefined,
    grok: undefined,
  });
  const [conversationIds, setConversationIds] = useState<Record<AIModel, string>>({
    mdai: '',
    chatgpt: '',
    gemini: '',
    deepseek: '',
    metaai: '',
    perplexity: '',
    claude: '',
    grok: '',
  });
  const [editName, setEditName] = useState('');
  const [editingId, setEditingId] = useState<number | null>(null);
  const { showSnackBar } = useSnackBar();
  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const isSmallScreen = useMediaQuery('(max-width:1024px)');
  const aiActions = AiActions();
  const scrollContainerRef = React.useRef<HTMLDivElement>(null);
  const [activeModelTab, setActiveModelTab] = useState<number>(0);
  const [isModalOpen, setModalOpen] = useState(false);
  const [errors, setErrors] = useState<any>('');
  const [isSaving, setIsSaving] = useState(false);
  const [phoneNumber, setPhoneNumber] = useState('');
  const [historyRefresh, setHistoryRefresh] = useState(0);

  useEffect(() => {
    setSelectedQuery(null);
    setLastQueryText({
      mdai: '',
      chatgpt: '',
      gemini: '',
      deepseek: '',
      metaai: '',
      perplexity: '',
      claude: '',
      grok: '',
    });
    setResponses({
      mdai: undefined,
      chatgpt: undefined,
      gemini: undefined,
      deepseek: undefined,
      metaai: undefined,
      perplexity: undefined,
      claude: undefined,
      grok: undefined,
    });
    setConversationIds({
      mdai: '',
      chatgpt: '',
      gemini: '',
      deepseek: '',
      metaai: '',
      perplexity: '',
      claude: '',
      grok: '',
    });
    setLastQuerySource(null);

    setChatInputState(prevState => ({
      ...prevState,
      query: '',
      conversation_id: '',
    }));
  }, [chatInputState.selectedCampaign]);

  const handleSubmit = () => {
    setErrors('');

    if (!phoneNumber) {
      setErrors('Phone number is required.');
      return;
    }
    if (/[^0-9]/.test(phoneNumber)) {
      setErrors('Phone number should only contain digits.');
      return;
    }
    if (phoneNumber.length < 10) {
      setErrors('Phone number must be at least 10 digits long.');
      return;
    }
    localStorage.setItem('phoneNumber', phoneNumber);
    setIsSaving(true);
    setModalOpen(false);
  };

  useEffect(() => {
    const storedPhone = localStorage.getItem('phoneNumber');
    if (!storedPhone) {
      setModalOpen(true);
    }
  }, []);

  const handleClose = () => {
    setModalOpen(false);
  };

  const handleChangeModelTab = (event: React.SyntheticEvent, newValue: number) => {
    setActiveModelTab(newValue);
  };
  const [fullScreenModel, setFullScreenModel] = useState<AIModel | null>(null);

  const scroll = (direction: 'left' | 'right') => {
    if (scrollContainerRef.current) {
      const scrollAmount = 600; // Width of one chat window + gap
      scrollContainerRef.current.scrollBy({
        left: direction === 'left' ? -scrollAmount : scrollAmount,
        behavior: 'smooth',
      });
    }
  };

  const getPairedMDModel = (model: AIModel): AIModel => {
    switch (model) {
      case 'chatgpt':
        return 'mdai';
      case 'gemini':
        return 'mdai+gemini';
      case 'claude':
        return 'mdai+claude';
      case 'grok':
        return 'mdai+grok';
      case 'metaai':
        return 'mdai+metaai';
      case 'perplexity':
        return 'mdai+perplexity';
      case 'deepseek':
        return 'mdai+deepseek';
      default:
        return 'mdai';
    }
  };

  const submitQuery = async (
    queryTextFromSubmit: string,
    model: AIModel,
    source: 'QueryInterface' | 'AISelection'
  ) => {
    const currentQueryText = queryTextFromSubmit.trim();
    if (!currentQueryText || loading[model]) return;

    setLoading((prev) => ({ ...prev, [model]: true }));
    setErrorMessage(null);
    setLastQueryText((prev) => ({ ...prev, [model]: currentQueryText }));
    setLastQuerySource(source);

    let effectivePrimaryModelKey: AIModel;
    effectivePrimaryModelKey = source === 'AISelection' ? getPairedMDModel(model) : model;

    try {
      const payload = {
        query: currentQueryText,
        ai_models: [effectivePrimaryModelKey],
        conversation_id: conversationIds[model] || selectedQuery?.conversation_id || '',
        organisation_id: chatInputState.selectedOrganisation?.organisation_id ?? '',
        campaign_id: chatInputState.selectedCampaign?.proposal_id ?? '',
        user_id: chatInputState.user_id ?? '',
        project_id: chatInputState?.selectedProject?.project_id ?? '',
        project_name: chatInputState?.selectedProject?.project_name ?? '',
        initial_query_id: chatInputState?.initial_query_id ?? '',
      };

      const responseFromAPI = await aiActions.sendChatGptQuery(payload);
      if (responseFromAPI?.status === 200 && responseFromAPI.data) {
        const { responses: apiResponses, conversation_id, created_at } = responseFromAPI.data;
        let mainApiResponseText = '';

        // Get response based on model
        if (apiResponses[model]) {
          mainApiResponseText = apiResponses[model]?.text?.response || '';
        } else if (apiResponses[effectivePrimaryModelKey]) {
          mainApiResponseText = apiResponses[effectivePrimaryModelKey]?.text?.toString() || '';
        }

        setResponses((prev) => ({ ...prev, [model]: mainApiResponseText }));
        setConversationIds((prev) => ({ ...prev, [model]: conversation_id }));
        setHistoryRefresh((prev) => prev + 1);

        const updatedSelectedQueryData = {
          ...payload,
          conversation_id: conversation_id,
          AImodel: effectivePrimaryModelKey,
          created_at: new Date(created_at),
        };
        setSelectedQuery(updatedSelectedQueryData);
        setChatInputState((prevState) => ({
          ...prevState,
          query: '',
          conversation_id: conversation_id,
        }));

        if (!payload?.conversation_id) {
          if (updatedSelectedQueryData?.project_id) {
            setProjectAndQueryList((prev) => ({
              ...prev,
              [updatedSelectedQueryData?.project_id]: [
                { ...updatedSelectedQueryData },
                ...prev?.[updatedSelectedQueryData?.project_id],
              ],
            }));
          } else {
            setProjectAndQueryList((prev) => ({
              ...prev,
              [updatedSelectedQueryData.campaign_id]: [
                { ...updatedSelectedQueryData },
                ...prev?.[updatedSelectedQueryData.campaign_id],
              ],
            }));
          }
        }
      } else {
        throw new Error(responseFromAPI?.data?.error || 'Failed to get response from AI');
      }
    } catch (error) {
      showSnackBar(`Failed to get response from ${model}. Please try again.`, 'error');
      setResponses((prev) => ({ ...prev, [model]: undefined }));
    } finally {
      setLoading((prev) => ({ ...prev, [model]: false }));
    }
  };

  const onSelectQuery = (query: Query) => {
    setSelectedQuery(query);
    setChatInputState((prevState) => ({
      ...prevState,
      query: '',
      ai_model: query.AImodel || 'chatgpt',
      conversation_id: query.conversation_id,
    }));
    setLastQueryText({
      mdai: '',
      chatgpt: '',
      gemini: '',
      deepseek: '',
      metaai: '',
      perplexity: '',
      claude: '',
      grok: '',
    });
    setResponses({
      mdai: undefined,
      chatgpt: undefined,
      gemini: undefined,
      deepseek: undefined,
      metaai: undefined,
      perplexity: undefined,
      claude: undefined,
      grok: undefined,
    });
    // Set conversation ID for all AI models when selecting a chat
    setConversationIds({
      mdai: query.conversation_id,
      chatgpt: query.conversation_id,
      gemini: query.conversation_id,
      deepseek: query.conversation_id,
      metaai: query.conversation_id,
      perplexity: query.conversation_id,
      claude: query.conversation_id,
      grok: query.conversation_id,
    });
  };

  const startEditing = (id: number, name: string) => {
    setEditingId(id);
    setEditName(name);
  };

  const saveName = (id) => {
    setEditingId(null);
    setEditName('');
  };

  const cancelEdit = () => {
    setEditingId(null);
    setEditName('');
  };

  const handleInitiateNewChat = async () => {
    setSelectedQuery(null);
    setLastQueryText({
      mdai: '',
      chatgpt: '',
      gemini: '',
      deepseek: '',
      metaai: '',
      perplexity: '',
      claude: '',
      grok: '',
    });
    setResponses({
      mdai: undefined,
      chatgpt: undefined,
      gemini: undefined,
      deepseek: undefined,
      metaai: undefined,
      perplexity: undefined,
      claude: undefined,
      grok: undefined,
    });
    setConversationIds({
      mdai: '',
      chatgpt: '',
      gemini: '',
      deepseek: '',
      metaai: '',
      perplexity: '',
      claude: '',
      grok: '',
    });
  };

  return (
    <>
      {isSmallScreen ? (
        <Box display="flex" flexDirection="column" gap={2} sx={{ height: { xs: '100%', sm: '100%', md: 'auto' } }}>
          {/* Sidebar stays same */}
          <LeftSidebar
            selectedQuery={selectedQuery}
            onSelectQuery={onSelectQuery}
            editingId={editingId}
            editName={editName}
            setEditName={setEditName}
            startEditing={startEditing}
            saveName={saveName}
            cancelEdit={cancelEdit}
            onInitiateNewChat={handleInitiateNewChat}
          />
          {/* Tabs for switching AI models */}
          <Tabs
            value={activeModelTab}
            onChange={handleChangeModelTab}
            variant="scrollable"
            scrollButtons="auto"
            allowScrollButtonsMobile
            sx={{
              mb: 1,
              borderBottom: '1px solid #ddd',
              mx: 2,
              '& .MuiTabs-list': { justifyContent: 'space-between' },
            }}
          >
            {aiModels.map((m, idx) => (
              <Tab key={m.model} label={m.label} />
            ))}
          </Tabs>
          {/* Tab panels */}
          {aiModels.map((m, idx) => (
            <Box
              key={m.model}
              hidden={activeModelTab !== idx}
              sx={{
                overflowX: 'auto',
                height: { xs: '100%', sm: '100%', md: '70vh' }
              }}
            >
              <Paper
                elevation={3}
                sx={{
                  height: '100%',
                  display: 'flex',
                  flexDirection: 'column',
                }}
              >
                {/* Header */}
                {/* <Box
                  sx={{
                    p: 2,
                    backgroundColor: m.color,
                    color: 'white',
                    border: `1px solid ${m.color}`,
                  }}
                >
                  <Typography variant="h6" fontWeight={500}>
                    {m.label}
                  </Typography>
                </Box> */}
                {/* Chat Interface */}
                <Box sx={{ flexGrow: 1, overflow: 'hidden' }}>
                  <AIWindowContent
                    aiModel={m.model}
                    aiLabel={m.label}
                    selectedQuery={selectedQuery}
                    submitQuery={(text, context) =>
                      submitQuery(text, m.model, 'QueryInterface', context)
                    }
                    loading={loading[m.model]}
                    lastQueryText={lastQueryText[m.model]}
                    lastQuerySource={lastQuerySource}
                    response={responses[m.model]}
                    conversationId={conversationIds[m.model]}
                    historyRefresh={historyRefresh}
                  />
                </Box>
              </Paper>
            </Box>
          ))}
        </Box>
      ) : (
        // <Box display="flex" gap={2} flexDirection="column">
        //   <LeftSidebar
        //     selectedQuery={selectedQuery}
        //     onSelectQuery={onSelectQuery}
        //     editingId={editingId}
        //     editName={editName}
        //     setEditName={setEditName}
        //     startEditing={startEditing}
        //     saveName={saveName}
        //     cancelEdit={cancelEdit}
        //     onInitiateNewChat={handleInitiateNewChat}
        //   />

        //   {/* Mobile: Show selected AI only */}
        //   <QueryInterface
        //     selectedQuery={selectedQuery}
        //     submitQuery={(text, _, context) => submitQuery(text, chatInputState.ai_model, 'QueryInterface', context)}
        //     loading={loading[chatInputState.ai_model]}
        //     lastQueryText={lastQueryText[chatInputState.ai_model]}
        //     lastQuerySource={lastQuerySource}
        //     selectedAI={chatInputState.ai_model}
        //   />
        // </Box>
        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: '300px 1fr',
            gap: 2,
            height: '86vh',
            p: 0,
            boxSizing: 'border-box',
            position: 'relative',
            overflow: 'hidden',
          }}
        >
          {errorMessage && (
            <Typography
              color="error"
              sx={{
                fontWeight: 'bold',
                fontSize: '1.2rem',
                padding: 2,
                backgroundColor: 'rgba(255, 0, 0, 0.1)',
                borderRadius: 2,
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                zIndex: 10,
              }}
            >
              {errorMessage}
            </Typography>
          )}

          {/* Left Sidebar */}
          <LeftSidebar
            selectedQuery={selectedQuery}
            onSelectQuery={onSelectQuery}
            editingId={editingId}
            editName={editName}
            setEditName={setEditName}
            startEditing={startEditing}
            saveName={saveName}
            cancelEdit={cancelEdit}
            onInitiateNewChat={handleInitiateNewChat}
          />

          {/* Horizontally Scrollable AI Windows */}
          <Box sx={{ position: 'relative', overflow: 'hidden' }}>
            {/* Left Scroll Button */}
            <IconButton
              onClick={() => scroll('left')}
              sx={{
                position: 'absolute',
                left: 2,
                top: '50%',
                transform: 'translateY(-50%)',
                zIndex: 10,
                backgroundColor: 'white',
                boxShadow: 3,
                '&:hover': {
                  backgroundColor: 'grey.100',
                },
              }}
            >
              <ChevronLeftIcon sx={{ fontSize: { xs: '24px', sm: '24px', md: '26px' } }} />
            </IconButton>

            {/* Scrollable Container */}
            <Box sx={{ position: 'relative', overflow: 'hidden', height: '100%' }}>
              {fullScreenModel ? (
                // Full-screen mode: only show selected AI window
                <Paper
                  elevation={3}
                  sx={{
                    height: '100%',
                    width: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    position: 'relative',
                  }}
                >
                  {/* Header */}
                  <Box
                    sx={{
                      p: '10px 8px',
                      backgroundColor:
                        aiModels.find((m) => m.model === fullScreenModel)?.color || '#fff',
                      color: 'black',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                      borderBottom: `1px solid #e5e7eb`,
                    }}
                  >
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                      <Box sx={{ width: '30px', height: '30px' }}>
                        <img
                          src={aiLogos[fullScreenModel]}
                          alt={fullScreenModel}
                          style={{ width: '100%', height: '100%' }}
                        />
                      </Box>
                      <Typography>
                        {aiModels.find((m) => m.model === fullScreenModel)?.label}
                      </Typography>
                    </Box>

                    {/* Close full-screen */}
                    <IconButton size="small" onClick={() => setFullScreenModel(null)}>
                      ❌
                    </IconButton>
                  </Box>

                  {/* Chat Interface */}
                  <Box sx={{ flexGrow: 1, overflow: 'hidden' }}>
                    <AIWindowContent
                      aiModel={fullScreenModel}
                      aiLabel={aiModels.find((m) => m.model === fullScreenModel)?.label || ''}
                      selectedQuery={selectedQuery}
                      submitQuery={(text, context) =>
                        submitQuery(text, fullScreenModel, 'QueryInterface', context)
                      }
                      loading={loading[fullScreenModel]}
                      lastQueryText={lastQueryText[fullScreenModel]}
                      lastQuerySource={lastQuerySource}
                      response={responses[fullScreenModel]}
                      conversationId={conversationIds[fullScreenModel]}
                      historyRefresh={historyRefresh}
                    />
                  </Box>
                </Paper>
              ) : (
                <Box
                  ref={scrollContainerRef}
                  sx={{
                    display: 'flex',
                    gap: 1,
                    overflowX: 'auto',
                    overflowY: 'hidden',
                    height: '100%',
                    scrollBehavior: 'smooth',
                    '&::-webkit-scrollbar': {
                      height: '5px',
                    },
                    '&::-webkit-scrollbar-track': {
                      background: '#f1f1f1',
                      borderRadius: '10px',
                    },
                    '&::-webkit-scrollbar-thumb': {
                      background: '#888',
                      borderRadius: '10px',
                      '&:hover': {
                        background: '#555',
                      },
                    },
                    px: { xs: '12px', sm: '40px' },
                  }}
                >
                  {aiModels.map((aiModel) => (
                    <Box
                      key={aiModel.model}
                      sx={{
                        minWidth: { xs: 'calc(100vw - 32px)', sm: '550px' },
                        maxWidth: { xs: 'calc(100vw - 32px)', sm: '550px' },
                        height: '100%',
                        flexShrink: 0,
                      }}
                    >
                      <Paper
                        elevation={3}
                        sx={{
                          height: '100%',
                          display: 'flex',
                          flexDirection: 'column',
                          margin: { xs: '0px', sm: '0px 10px' },
                          justifyContent: 'space-between',
                          borderTop: `1px solid #e5e7eb`,
                        }}
                      >
                        {/* Header */}
                        <Box
                          sx={{
                            p: '10px 8px',
                            backgroundColor: aiModel.color,
                            color: 'black',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between', // pushes items to edges
                            borderBottom: `1px solid #e5e7eb`,
                          }}
                        >
                          {/* Left side: logo + label */}
                          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                            <Box sx={{ width: '30px', height: '30px' }}>
                              {aiLogos[aiModel.model] && (
                                <img
                                  src={aiLogos[aiModel.model]}
                                  alt={aiModel.label}
                                  style={{ width: '100%', height: '100%' }}
                                />
                              )}
                            </Box>
                            <Typography>{aiModel.label}</Typography>
                          </Box>

                          {/* Right side: OpenInNewIcon */}
                          <IconButton
                            size="small"
                            onClick={() => setFullScreenModel(aiModel.model)}
                          >
                            <OpenInNewIcon fontSize="small" />
                          </IconButton>
                        </Box>

                        {/* Chat Interface */}
                        <Box sx={{ flexGrow: 1, overflow: 'hidden' }}>
                          <AIWindowContent
                            aiModel={aiModel.model}
                            aiLabel={aiModel.label}
                            selectedQuery={selectedQuery}
                            submitQuery={(text, context) =>
                              submitQuery(text, aiModel.model, 'QueryInterface', context)
                            }
                            loading={loading[aiModel.model]}
                            lastQueryText={lastQueryText[aiModel.model]}
                            lastQuerySource={lastQuerySource}
                            response={responses[aiModel.model]}
                            conversationId={conversationIds[aiModel.model]}
                            historyRefresh={historyRefresh}
                          />
                        </Box>
                      </Paper>
                    </Box>
                  ))}
                </Box>
              )}
            </Box>

            {/* Right Scroll Button */}
            <IconButton
              onClick={() => scroll('right')}
              sx={{
                position: 'absolute',
                right: 2,
                top: '50%',
                transform: 'translateY(-50%)',
                zIndex: 10,
                backgroundColor: 'white',
                boxShadow: 3,
                '&:hover': {
                  backgroundColor: 'grey.100',
                },
              }}
            >
              <ChevronRightIcon sx={{ fontSize: { xs: '24px', sm: '24px', md: '26px' } }} />
            </IconButton>
          </Box>
        </Box>
      )}

      {isModalOpen && (
        <ModalForms
          show={open}
          handleClose={handleClose}
          modalHeader={'Enter'}
          size="md"
          modalBody={
            <Box>
              <TextField
                fullWidth
                label={
                  <Typography component="span">
                    Phone Number <span style={{ color: 'red' }}>*</span>
                  </Typography>
                }
                placeholder="Enter Mobile Number"
                variant="outlined"
                size="small"
                value={phoneNumber}
                onChange={(e) => {
                  const value = e.target.value.replace(/\D/g, '');
                  setPhoneNumber(value);
                  setErrors('');
                }}
                error={!!errors}
                helperText={errors}
                inputProps={{
                  maxLength: 10,
                  inputMode: 'numeric',
                  pattern: '[0-9]*',
                }}
              />
            </Box>
          }
          modalFooter={
            <Box display="flex" justifyContent="flex-end" gap={2}>
              <Button variant="outlined" size="small" onClick={handleClose}>
                Cancel
              </Button>
              <Button variant="contained" size="medium" onClick={handleSubmit} disabled={isSaving}>
                Save
              </Button>
            </Box>
          }
        />
      )}
    </>
  );
}
